export const SEASONAL_ILLUSTRATIONS = {
  easter: { light: "paskekanin", dark: "paskekanin" },
  nationalDayNO: { light: "17-mai", dark: "17-mai-dark" },
  pride: { light: "pride", dark: "pride-dark" },
  halloween: { light: "halloween", dark: "halloween-dark" },
  friday13th: { light: "friday-13th", dark: "friday-13th-dark" },
  christmas: { light: "julekrans", dark: "julekrans" },
} as const;
